export default __webpack_public_path__ + "assets/20790aeca3fbacaf12be5a57eb669f05.png";